export enum ActivityTypeEnum {
    LOGIN = 'LOGIN',
    LOGIN_ERROR = 'LOGIN_ERROR',
    NEPTUNE_SSO_OAUTH_REDIRECT = 'NEPTUNE_SSO_OAUTH_REDIRECT',
    UPDATE = 'UPDATE',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    CREATE = 'CREATE'
}

export enum PasswordEventTypeEnum {
    FORGOT_PASSWORD_REQUESTED = 'FORGOT_PASSWORD_REQUESTED',
    PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS',
    PASSWORD_CHANGED = 'PASSWORD_CHANGED',
}

export enum MethodTypeEnum {
    NEPTUNE_USER_SIGN_ON = 'NEPTUNE_USER_SIGN_ON',
    AGILITY_USER_SIGN_ON = 'AGILITY_USER_SIGN_ON',
    NEPTUNE_SSO_CLASSIC = 'NEPTUNE_SSO_CLASSIC',
    NEPTUNE_SSO_OAUTH = 'NEPTUNE_SSO_OAUTH',
}

export enum IssueTypeEnum {
    SESSION_LIMIT_EXCEEDED = 'SESSION_LIMIT_EXCEEDED',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    UNKNOWN_USER = 'UNKNOWN_USER',
    INACTIVE_USER = 'INACTIVE_USER',
    NO_ACTIVE_ACCOUNTS = 'NO_ACTIVE_ACCOUNTS',
    RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
    PRIMARY_ACCOUNT_NOT_ACTIVE = 'PRIMARY_ACCOUNT_NOT_ACTIVE',
    SSO_FAILURE = 'SSO_FAILURE',
    MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED',
    MFA_VALIDATION_REQUIRED = 'ED',
    MFA_VALIDATION_FAILED = 'MFA_VALIDATION_FAILED',
    SSO_INVALID_NONCE = 'SSO_INVALID_NONCE',
    SSO_LOGIN_EXPIRED = 'SSO_LOGIN_EXPIRED',
    SSO_TOKEN_EXCHANGE_ERROR = 'SSO_TOKEN_EXCHANGE_ERROR',
    SSO_TOKEN_VALIDATION_ERROR = 'SSO_TOKEN_VALIDATION_ERROR'
}
